import styled from '@emotion/styled';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';

import {Logo} from '@ELib/assets/images';
import {ESmallButton} from '@ELib/components/EButtons';
import {getOS, isElectron} from '@ELib/utilities/HelperFunctions';
import {downloadStaticFile} from '@ELib/utilities/download';
import {useMountEffect} from '@ELib/utilities/hooks/effectHelpers';
import {OSTypes} from '@ELib/utilities/types';
import {getBootstrapVersion} from '@ELib/utilities/version';

type DownloadableArtifact = {name: string; urlPart: string};

export const AuthWorkflowFooter = (): React.ReactElement => {
  const [browserArtefacts, setBrowserArtefacts] = useState<
    DownloadableArtifact[]
  >([]);

  const {t} = useTranslation('lib');

  useMountEffect(() => {
    if (!isElectron()) {
      (async () => {
        const os = getOS();
        if (os === OSTypes.iOS || os === OSTypes.Android) {
          return;
        }

        const version = await getBootstrapVersion();
        if (!version) {
          return;
        }

        setBrowserArtefacts([
          {
            name: 'Windows EXE',
            urlPart: `LEXIAN (AutoUpdate) ${version}.exe`,
          },
          {
            name: 'Windows MSI',
            urlPart: `LEXIAN ${version}.msi`,
          },
          {
            name: 'Mac OS',
            urlPart: `LEXIAN ${version}.dmg`,
          },
          {
            name: 'Linux',
            urlPart: `LEXIAN ${version}.AppImage`,
          },
        ]);
      })();
    }
  });

  return (
    <Wrapper>
      <Logo />
      {!isElectron() ? (
        <ButtonRow>
          <ESmallButton
            disabled={browserArtefacts.length < 1}
            extraActions={browserArtefacts.map((artifact) => ({
              id: artifact.urlPart,
              text: `${artifact.name} - ${artifact.urlPart}`,
              callback: () =>
                downloadStaticFile(`/bootstrap-browser/${artifact.urlPart}`),
            }))}
          >
            {t('login.downloads.browser')}
          </ESmallButton>
        </ButtonRow>
      ) : null}
    </Wrapper>
  );
};

const ButtonRow = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  margin-top: var(--gutter-big);
  width: 100%;
  flex-wrap: wrap;
  gap: var(--gutter);
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  margin-top: var(--gutter-big);
  width: 100%;

  svg {
    align-self: center;
  }
`;
